import React from 'react';
import { connect } from 'react-redux';

export const RenderCustomReportCheckbox = ({
  children,
  checkboxName,
  isOCR,
}) => {
  const _shouldRenderCheckbox = (checkboxName) => {
    switch (checkboxName) {
      case 'BLACKLINE_CHECK_BOXES':
        return !isOCR;
      default:
        return true;
    }
  };
  return _shouldRenderCheckbox(checkboxName) ? <>{children}</> : <></>;
};

const mapStateToProps = ({
  data: {
    selectedStatement: { isOCR },
  },
}) => ({
  isOCR,
});
export default connect(mapStateToProps, null)(RenderCustomReportCheckbox);
